import { Box, keyframes, styled } from '@mui/material';

const gradientShift = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const AnimatedChatbotIconBase = styled(Box)<{ size?: number }>`
  width: ${({ size = 130 }) => size}px;
  height: ${({ size = 130 }) => size}px;
  background: linear-gradient(142.43deg, #1bc8ff 35.03%, #9789ff 50.24%, #1bc8ff 100%);
  background-size: 200% 100%;
  animation: ${gradientShift} 4s ease-in-out;

  -webkit-mask: url('/images/icons/chatbot-icon.svg') no-repeat center;
  mask: url('/images/icons/chatbot-icon.svg') no-repeat center;
  -webkit-mask-size: contain;
  mask-size: contain;
`;

interface AnimatedChatbotIconProps {
  size?: number;
  className?: string;
}

export const AnimatedChatbotIcon = ({ size = 130, className }: AnimatedChatbotIconProps) => {
  return <AnimatedChatbotIconBase size={size} className={className} data-testid='animated-chatbot-icon' />;
};
